export enum ChecklistDocumentCategories {
  PERSONAL = 'personal',
  GENERAL = 'general',
  INCOME = 'incomeDependent',
  PURPOSE = 'purposeDependent',
  PROTECTION = 'protectionDependent',
}
